import { Person } from './domain';
import { refreshFetch } from './refresh-fetch';
import { authHeader } from './';
import { showToast } from './toast';

function jwtFetch(): (input: RequestInfo, init?: RequestInit) => Promise<any> {
  return (input, init) => {
    const token = 'NO_JWT'

    return fetch(input, authHeader(token, init))
      .then((response) => {
        if (response.status === 401 || response.status === 403) {
          console.log('jwtFetch 401', response);
          return response;
          // return onSessionExpired();
        }

        const contentType = response?.headers?.get('content-type');
        if (contentType && contentType.indexOf('json') !== -1) {
          return response.json();
        }

        const contentLength = response?.headers?.get('content-length');
        if (!contentLength || !contentLength.length) {
          return response.text();
        }
        return response.text();
      })
      .catch((e) => {
        const message: string = (e || '').toString().toLowerCase();
        showToast(message);
        return Promise.reject(message);
      });
  };
}

type AuthApi = {
  fetch: <T = any>(input: RequestInfo, init?: RequestInit) => Promise<T>;
  signedIn?: Person;
  signOut: (force?:boolean) => void;
  isAuthenticated: () => boolean;
  refreshToken: () => string
};

function authApi(): AuthApi {
  const api: any = {};
  api.fetch = refreshFetch({
    fetch: jwtFetch(),
    refreshToken: () => null,
  });
  api.signedIn = null;
  api.isAuthenticated = () => false;
  return api;
}

export const auth = authApi();


